import {
    getCurrentCameraDistance,
    getOrbitControlsDistanceAndPan,
    getPolarAngleFromViewMode,
    getWorldData,
    setMinAndMaxControlsDistance,
    setOrbitControls, setPanLimits,
    setPolarAngle,
} from '../controls/orbitControls';
import { ViewMode } from '../../common';
import {
    Buildings,
    components,
    GSAPAnimationMixer,
    isMobile,
    projectMode,
    settingsData,
    threeJsVariables, TRoot
} from '../../settings';
import { moveElements } from '../menu/navigation/right-nav-bar';
import {
    cylinderFloorNumbers,
    removeCylinderFloorNumbers, rotateCylinderFloorNumbers, showOrHideCylinderFloorNumbers,
} from '../components/cylinderFloorNumbers/cylinderFloorNumbers';
import { FloorSlider } from '../components/floorSlider/floorSlider';
import {
    enableSwitcherBtns, getCylinderModeControlsType, isCylinderDisplayModeEqual, isOneMesh,
    rotation_to_flat,
    setColorsKeyPlan,
    userPrevent,
} from '../../functions';
import {
    floorMoveAnimation
} from '../controls/destroyBuilding';
import {
    disableArrowButtons,
    moveCardWhenBuildingDestroyed
} from '../cards/unitCards/unitCardFunctions';
import {Box3, Vector3} from 'three';
import { animateCamera } from '../threejs/animation';
import TWEEN from '../../libs/tween.umd';
import { flatLabels, flatLabelsRemove } from '../components/flatLabels/flatLabels';
import { renderUpdateValuesOnDemand } from '../../app';
import { Amenities } from '../components/Amenities/Amenities';
import { CylinderBase } from '../cylinderGrid/CylinderBase';
import { Favorite } from '../components/Favorite/Favorite';
import { FloorAmenities } from '../components/Amenities/FloorAmenities';
import { hideSceneObjects, showSceneObjects } from '../points/points';
import {BaseElement} from "../interfaces/BaseElement";
import {changeLangToCurrent} from "../components/langSwitcher/langSwitcher";

export class FloorPlan {
    #backButton;

    constructor () {
        this.minAngle = getPolarAngleFromViewMode(ViewMode.FloorPlan).minAngle;
        this.minDistance = null;
        this.maxDistance = null;
        this.buildingSwitcher = null;
        this.floorSlider = null;
        this.floorAmenities = new FloorAmenities();
        this.startHeight = null;
    }

    async enter(){
        if (userPrevent())
            return;

        return new Promise(resolve => {
            userPrevent(true);

            if (config.resources.sceneObjects.hideAttachedModelInKeyPlan)
                hideSceneObjects();

            settingsData.activeModeSwitching = true;

            if (!isMobile) {
                this.buildingSwitcher = document.getElementById('building-switcher');
                this.buildingSwitcher && this.buildingSwitcher.classList.add('hide');
                enableSwitcherBtns(true);
            }

            this.updateVariables();
            const activeBuilding = Buildings.getActiveBuilding();
            if (!projectMode.LiteMode.isActive() || projectMode.LiteMode.isActive() && (projectMode.LiteMode.modeIs('regular') || projectMode.LiteMode.modeIs('rotate'))) {
                if (!threeJsVariables.slicer.active){
                    const roof = activeBuilding.amenities['Roof'].mesh;
                    roof.position.y = roof.position.y + 400;
                }
            }

            settingsData.buildingDestroyed = true;

            if (!isMobile)
                Amenities.hide();
            Amenities.hideAmenitiesSelectionBoxes();

            if (!isMobile)
                disableArrowButtons();

            removeCylinderFloorNumbers();
            Favorite.toggle('hide');
            this.startHeight = threeJsVariables.orbitControls.target.y;
            threeJsVariables.perspectiveCamera.userData.startAnimationDistance = getCurrentCameraDistance();
            const {floorVector,flatVector} = getWorldData(settingsData.lastClickedFlat);
            const destroyTarget = new Vector3(flatVector.x,floorVector.y,flatVector.z);
            document.getElementById('app').classList.remove('cylinder-mode');
            document.getElementById('app').classList.add('floor-plan-mode');

            const mixer = GSAPAnimationMixer.registerNewMixer('floorPlan');
            mixer.addCallback('onComplete',() => {
                CylinderBase.rotateTexts();
                flatLabels({currentFloor: settingsData.currentFloor});
                userPrevent(false);
                setOrbitControls(ViewMode.FloorPlan);
                setPolarAngle(ViewMode.FloorPlan);
                setMinAndMaxControlsDistance(ViewMode.FloorPlan);
                projectMode.QA.tests.Vantages?.initFloorValidator();
                this.#addBackButton();
                if (isMobile) {
                    components.mobileSearch.filterCards(activeBuilding.name);
                    components.mobileSearch.fold();
                }

                resolve(true);
            });

            if (threeJsVariables.slicer.active && !isOneMesh()) {
                const copyBuildingAnimation = threeJsVariables.slicer.keyPlanEnter(activeBuilding);
                mixer.addAnimation(copyBuildingAnimation);
            }

            this.destroyBuilding(settingsData.currentFloor,destroyTarget,'enter');

            moveElements();
            settingsData.activeViewMode = 'floorplan';
            setColorsKeyPlan(settingsData.currentFloor);
            // if (isMobile) {
                // components.mobileSearch.setStateTo('hidden');
                // components.mobileSearch.update('orientation');
            // }
            mixer.play();

            setTimeout(() => {
                this.floorSlider = new FloorSlider();
                this.floorSlider.create().then(() => {
                    moveCardWhenBuildingDestroyed();
                });
            }, 200);
            settingsData.activeModeSwitching = false;
        });
    }

    async up(floor, apartment){
        return new Promise(resolve => {
            userPrevent(true);
            this.floorSlider.block();
            flatLabelsRemove();
    
            let mixer = GSAPAnimationMixer.getMixer('floorPlan');
            if (!mixer) {
                mixer = GSAPAnimationMixer.registerNewMixer('floorPlan');
            }
    
            mixer.addCallback('onComplete',() => {
                flatLabels({currentFloor: floor});
                userPrevent(false);
                projectMode.QA.tests.Vantages?.initFloorValidator();
                this.floorSlider.unblock();
                resolve();
            });
    
            const flat = this.#flatWithCrmData(floor);
            settingsData.aptFloorNum = flat.userData.crm_data.floorNum;
            floorMoveAnimation(settingsData.currentFloor, 'appear', floor);
    
            settingsData.currentFloor = floor;
            this.floorSlider.updateScroll(floor);
            setColorsKeyPlan(floor);
            const {cameraVector} = getWorldData(flat);
            let target = new Vector3().copy(cameraVector).setY(flat.userData.baseWorldPosition.y);
            this.destroyCameraAnimation(target, `appear`,flat);
    
            if (apartment && apartment.isMesh)
                rotation_to_flat(apartment);
            mixer.play();
        })
    }

    async down(floor,apartment){
        return new Promise(resolve => {
            userPrevent(true);
            this.floorSlider.block();
            flatLabelsRemove();
    
            let mixer = GSAPAnimationMixer.getMixer('floorPlan');
            if (!mixer) {
                mixer = GSAPAnimationMixer.registerNewMixer('floorPlan');
            }
    
            mixer.addCallback('onComplete',() => {
                flatLabels({currentFloor: floor});
                userPrevent(false);
                projectMode.QA.tests.Vantages?.initFloorValidator();
                this.floorSlider.unblock();
                resolve();
            });
    
            // const activeBuilding = Buildings.getActiveBuilding();
            // const flat = activeBuilding.getFloorSelections(floor,false)[0];
            const flat = this.#flatWithCrmData(floor);
            settingsData.currentFloor = floor;
            settingsData.aptFloorNum = flat.userData.crm_data.floorNum;
            flat.updateWorldMatrix(true, false);
            const {cameraVector} = getWorldData(flat);
            let targetPosition =
                new Vector3()
                    .copy(cameraVector)
                    .setY(flat.userData.baseWorldPosition.y);
    
            setColorsKeyPlan(floor);
            this.destroyBuilding(floor, targetPosition);
    
            this.floorSlider.updateScroll(settingsData.currentFloor);
            if (apartment && apartment.isMesh)
                rotation_to_flat(apartment,true);
            mixer.play();
            // userPrevent(false);
            // this.floorSlider.unblock();
            // selectFirstAvailableApartmentOnTheFloor(floor);
        })
    }

    #flatWithCrmData(floor) {
        const activeBuilding = Buildings.getActiveBuilding();
        const flat = activeBuilding.getFloorSelections(floor,false).find(flat => flat.userData.crm_data);
        if (!flat) {
            console.log(`%cThe whole ${floor} floor of the ${activeBuilding.name} doesn't have CRM data`, 'color: orange');
            return false;
        } else {
            return flat;
        }
    }

    destroyBuilding(currentFloor_var, targetPosition,state){
        enableSwitcherBtns(false);
        settingsData.tween_animations = [];
        floorMoveAnimation(currentFloor_var, 'destroy',undefined,state);
        this.destroyCameraAnimation(targetPosition);
    }

    destroyCameraAnimation(targetPosition, upper, flat){
        const apt = flat ? flat : settingsData.lastClickedFlat;
        const {cameraVector, orbitControlsVector, flatVector} = getWorldData(apt);
        const distanceCorrection = config.threejs.orbitControls.floorplan.minDistanceCorrection;
        const position = targetPosition ? targetPosition : flatVector;
        const aptTarget = new Vector3().copy(orbitControlsVector).setY(position.y);
        const aptPosition =
            new Vector3()
                .subVectors(position,aptTarget)
                .normalize()
                .setY(position.y)
                // .setLength((this.minDistance + this.maxDistance) / 2 * distanceCorrection)
                .setLength(this.minDistance * distanceCorrection)
                .add(aptTarget);

        let mixer = GSAPAnimationMixer.getMixer('floorPlan');

        const cameraAnimation =  animateCamera(
            cameraVector,
            aptPosition,
            orbitControlsVector,
            aptTarget,
            undefined,
            // (this.minDistance + this.maxDistance) / 2,
            this.minDistance,
            this.minAngle,
            0,
            1000,
            TWEEN.Easing.Linear.None,
            () => {
                threeJsVariables.trackballControls.minDistance = this.minDistance;
            },
            () => {
                setMinAndMaxControlsDistance(ViewMode.FloorPlan);
                threeJsVariables.orbitControls.saveState();
            }
        );

        mixer.addAnimation(cameraAnimation);
    }

    async appearCameraAnimation(){
        const {minDistance,maxDistance} = getOrbitControlsDistanceAndPan(ViewMode.Cylinder);
        const {cameraVector, orbitControlsVector} = getWorldData();
        const {minAngle} = getPolarAngleFromViewMode(ViewMode.Cylinder);
        const cameraStartAnimationDistance = threeJsVariables.perspectiveCamera.userData.startAnimationDistance;
        const orbitSaveState = threeJsVariables.orbitControls.target0;
        orbitSaveState.y = this.startHeight;
        const position = new Vector3().subVectors(cameraVector,orbitControlsVector).normalize().setLength(cameraStartAnimationDistance).add(orbitSaveState);

        const animation =  animateCamera(
            cameraVector,
            position,
            orbitControlsVector,
            orbitSaveState,
            undefined,
            minDistance,
            minAngle,
            config.threejs.orbitControls.polarCameraCorrection,
            1000,
            TWEEN.Easing.Sinusoidal.InOut,
            () => {
                threeJsVariables.trackballControls.maxDistance = maxDistance;
            },
            () => {
        });

        GSAPAnimationMixer.addToMixer('floorPlan',animation);
    }

    updateVariables(){
        if (isMobile) {
            const boundingBox = new Box3(
                new Vector3(-15.561922073364258, 0.05396155267953873, -17.564775466918945),
                new Vector3(15.561922073364258, 30.06883430480957, 17.564775466918945)
            );

            const size = new Vector3();
            boundingBox.getSize(size);
            const center = new Vector3();
            boundingBox.getCenter(center);

            const maxSize = Math.max(size.x, size.y, size.z);
            // const fov = threeJsVariables.perspectiveCamera.fov * (Math.PI / 180);
            // const distance = maxSize / (2 * Math.tan(fov / 2));

            this.minDistance = maxSize * 2;
            this.maxDistance = maxSize * 2;
        } else {
            this.minDistance = getOrbitControlsDistanceAndPan(ViewMode.FloorPlan).minDistance;
            this.maxDistance = getOrbitControlsDistanceAndPan(ViewMode.FloorPlan).maxDistance;
        }
    }

    async exitFromMode(){
        if (userPrevent())
            return;

        return new Promise((resolve => {
            userPrevent(true);
            settingsData.activeModeSwitching = true;
            const mixer = GSAPAnimationMixer.registerNewMixer('floorPlan');
            document.getElementById('app').classList.remove('floor-plan-mode');
            document.getElementById('app').classList.add('cylinder-mode');
            mixer.addCallback('onStart', () => { this.#removeBackButton() });
            mixer.addCallback('onComplete',async () => {
                if (!projectMode.LiteMode.isActive() ||
                    projectMode.LiteMode.isActive() && (projectMode.LiteMode.modeIs('regular') || projectMode.LiteMode.modeIs('rotate'))) {
                    if (!threeJsVariables.slicer.active) {
                        const roof = Buildings.getActiveBuilding().amenities['Roof'].mesh;
                        roof.position.y = roof.position.y - 400;
                    }
                }

                if (isCylinderDisplayModeEqual('show all')) {
                    const controlsType = getCylinderModeControlsType();
                    setOrbitControls(controlsType);
                    setPolarAngle(controlsType);
                    setPanLimits(controlsType);
                    setMinAndMaxControlsDistance(controlsType);
                } else {
                    setOrbitControls(ViewMode.Cylinder);
                    setPolarAngle(ViewMode.Cylinder);
                    setPanLimits(ViewMode.Cylinder);
                    setMinAndMaxControlsDistance(ViewMode.Cylinder);
                }

                if (config.resources.sceneObjects.hideAttachedModelInKeyPlan) {
                    const building = Buildings.getActiveBuilding();
                    showSceneObjects(building);
                }

                Favorite.toggle('show');
                settingsData.activeViewMode = 'cylinder';
                setColorsKeyPlan();
                CylinderBase.rotateTexts();
                settingsData.activeModeSwitching = false;
                Favorite.intersect();
                projectMode.QA.tests.Vantages?.removeFloorValidator();
                cylinderFloorNumbers().then(() => {
                    showOrHideCylinderFloorNumbers();
                    rotateCylinderFloorNumbers();
                });
                userPrevent(false);
                resolve(true);
            });

            renderUpdateValuesOnDemand(false);
            settingsData.buildingDestroyed = false;
            settingsData.aptFloorNum = false;
            disableArrowButtons();
            Amenities.show();
            Amenities.showAmenitiesSelectionBoxes();
            if (!isMobile && Buildings.getBuildingsInfoLength() > 1) {
                this.buildingSwitcher.classList.remove('hide');
                enableSwitcherBtns(true);
            }
            flatLabelsRemove();
            if (this.floorSlider)
                this.floorSlider.remove();
            this.appearCameraAnimation();
            floorMoveAnimation(settingsData.currentFloor, 'appear',undefined,'exit');
            // if (isMobile) {
            //     components.mobileSearch.setStateTo('focused');
            //     components.mobileSearch.update();
            // }
            mixer.play();
        }));
    }

    #addBackButton() {
        if (!isMobile)
            return;

        this.#backButton = new BaseElement('button')
            .addClass('floor-plan__back-button', 'mobile-search__collapse-button', 'icon-back', 'language-string')
            .addAttribute('data-dictionary', 'Back')
            .innerHtml(changeLangToCurrent('Back'))
            .event('click', () => {
                this.exitFromMode();
                components.mobileSearch.unfold();
                components.mobileSearch.filterCards();
            })
            .appendTo(TRoot);
    }

    #removeBackButton() {
        if (!isMobile)
            return;

        this.#backButton.remove();
        this.#backButton = null;
    }
}
